import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type HotelEntity = {
  id: number;
  hotelPriority: number;
};

type SortHotelEntitiesPayload = {
  rooms: HotelEntity[];
  alwaysIncludedExperiences: HotelEntity[];
};

export function useSortHotelEntities({ hotelId }: { hotelId: number }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SortHotelEntitiesPayload) =>
      apiMutation(
        'POST',
        {
          path: ENDPOINTS.sortHotelEntities,
          params: { id: hotelId?.toString() },
        },
        payload
      ) as Promise<void>,
    onSuccess: () => {
      message.success('Hotel entities successfully sorted');

      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.hotelEntities, { id: hotelId }],
      });
    },
    onError: () => {
      message.error('Failed to sort Hotel entities.');
    },
  });
}
